export default __webpack_public_path__ + "static/media/prevIcon.738e44ba.svg";